"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _worksheetCard = require("./worksheetCard/worksheetCard");
require("./styles.scss");
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _discoverMore = _interopRequireDefault(require("./discover-more.svg"));
var _rightArrow = _interopRequireDefault(require("./right-arrow.svg"));
var _state = require("printableWorksheets/state");
var _printableWorksheets = require("printableWorksheets");
var _Scroller = _interopRequireDefault(require("schoolUiComponents/Scroller"));
var _FlexBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/FlexBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var WorksheetRail = function WorksheetRail(_ref) {
  var _ref$worksheets = _ref.worksheets,
    worksheets = _ref$worksheets === void 0 ? [] : _ref$worksheets,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Untitled' : _ref$title,
    _ref$playblesCount = _ref.playblesCount,
    playblesCount = _ref$playblesCount === void 0 ? 0 : _ref$playblesCount,
    _ref$nodeId = _ref.nodeId,
    nodeId = _ref$nodeId === void 0 ? "" : _ref$nodeId,
    _ref$item = _ref.item,
    item = _ref$item === void 0 ? {} : _ref$item;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice;
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    setActiveScreen = _usePrintableWorkshee.setActiveScreen,
    setSearchScreenData = _usePrintableWorkshee.setSearchScreenData,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    setActiveBreadcrumb = _usePrintableWorkshee.setActiveBreadcrumb,
    treeData = _usePrintableWorkshee.treeData,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    subjectCode = _usePrintableWorkshee.subjectCode;
  var switchToViewAllPage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setSearchScreenData({
              nodeId: nodeId,
              title: title,
              from: 'RAILS'
            });
            setActiveScreen(_state.PRINTABLE_WORKSHEET_SCREENS.SEARCH);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function switchToViewAllPage() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _findItemInNodeList = function findItemInNodeList(data, itemId) {
    if (data.id.toString() === itemId) {
      return data;
    } else {
      var res = null;
      for (var i = 0; i < data.children.length; i++) {
        res = _findItemInNodeList(data.children[i], itemId);
        if (res) {
          break;
        }
      }
      if (res) {
        return res;
      }
    }
  };
  if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ws-rail"
    }, /*#__PURE__*/_react["default"].createElement(_Scroller["default"], {
      onScrollChange: function onScrollChange(value) {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ws-rail__header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title"
    }, title), /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      gap: 16
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "view-printables"
      // onClick={() => switchToViewAllPage()}
      ,
      onClick: function onClick() {
        var _activeBreadcrumb$, _activeBreadcrumb;
        var item = (activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.title) == 'Math' ? _findItemInNodeList(treeData[1], nodeId) : _findItemInNodeList(treeData[0], nodeId);
        if ((activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb = activeBreadcrumb[(activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.length) - 1]) === null || _activeBreadcrumb === void 0 ? void 0 : _activeBreadcrumb.id) != item.id) {
          setActiveBreadcrumb([].concat(_toConsumableArray(activeBreadcrumb), [item]));
        }
      }
    }, "View all ".concat(playblesCount).concat(playblesCount > 1 ? " worksheets" : "worksheet")), /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      gap: 8
    }, /*#__PURE__*/_react["default"].createElement(_Scroller["default"].Prev, null), /*#__PURE__*/_react["default"].createElement(_Scroller["default"].Next, null)))), /*#__PURE__*/_react["default"].createElement(_Scroller["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
      gap: 20,
      fullWidth: true
    }, worksheets.map(function (worksheet, index) {
      if (index == worksheets.length - 1 && currentDevice === _AppMediaProvider.DeviceTypes.Mobile) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: worksheet.id
        }, /*#__PURE__*/_react["default"].createElement(_worksheetCard.WorksheetCard, {
          card: worksheet
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "discover-more-container",
          onClick: function onClick() {
            return switchToViewAllPage();
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "playbles-count"
        }, "+", playblesCount), /*#__PURE__*/_react["default"].createElement(_discoverMore["default"], null)));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: worksheet.id
        }, /*#__PURE__*/_react["default"].createElement(_worksheetCard.WorksheetCard, {
          card: worksheet
        }));
      }
    })))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-rail student ".concat(currentDevice === _AppMediaProvider.DeviceTypes.Mobile ? ' ws-rail-mobile-view' : ''),
    "data-sentry-component": "WorksheetRail",
    "data-sentry-source-file": "wsRail.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-rail__header student"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title student"
  }, title), currentDevice !== _AppMediaProvider.DeviceTypes.Mobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-printables-student"
    // onClick={() => switchToViewAllPage()}
    ,
    onClick: function onClick() {
      var _activeBreadcrumb$2, _activeBreadcrumb2;
      var item = (activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb$2 = activeBreadcrumb[0]) === null || _activeBreadcrumb$2 === void 0 ? void 0 : _activeBreadcrumb$2.title) == 'Math' ? _findItemInNodeList(treeData[1], nodeId) : _findItemInNodeList(treeData[0], nodeId);
      if ((activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb2 = activeBreadcrumb[(activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.length) - 1]) === null || _activeBreadcrumb2 === void 0 ? void 0 : _activeBreadcrumb2.id) != item.id) {
        setActiveBreadcrumb([].concat(_toConsumableArray(activeBreadcrumb), [item]));
      }
    }
  }, "View all ".concat(playblesCount).concat(playblesCount > 1 ? " worksheets" : " worksheet"), /*#__PURE__*/_react["default"].createElement(_rightArrow["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-rail__list".concat(worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD ? ' student-rail' : '')
  }, worksheets.map(function (worksheet, index) {
    if (index == worksheets.length - 1 && currentDevice === _AppMediaProvider.DeviceTypes.Mobile) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: worksheet.id
      }, /*#__PURE__*/_react["default"].createElement(_worksheetCard.WorksheetCard, {
        card: worksheet
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "discover-more-container",
        onClick: function onClick() {
          return switchToViewAllPage();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "playbles-count"
      }, "+", playblesCount), /*#__PURE__*/_react["default"].createElement(_discoverMore["default"], null)));
    } else {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: worksheet.id
      }, /*#__PURE__*/_react["default"].createElement(_worksheetCard.WorksheetCard, {
        card: worksheet
      }));
    }
  })));
};
var _default = exports["default"] = WorksheetRail;